import React, { Component, Fragment } from 'react';
import moment from 'moment';
import {
    convertTwoDecimalPoint, _addNotification, _addNotificationError, getModuleEnum,
    getAccessLevelByModule, isRegularLunchOrderType, getSchoolGrades, groupBy, getNotWorkingDays
} from '../../../server/util';
import {
    URL_VERSION, MealTypes, MenuOrderTypes, currency_symbol
} from '../../../server/constants';
import { get, postWithHeadersResponse, getRecipesDataByCode, formatNutritionFacts, getAllNutrientData } from '../../../server/actions'
import MonthCalender from '../../Misc/calender/monthCalender/monthCalender';
import NutritionCtrl from '../../../components/SchoolAdmin/Caterer/MenuMaster/nutritionCtrl'
import Modal from 'react-modal';
import { BeatLoader } from 'react-spinners';
import NutritioninfoNew from '../../SchoolAdmin/Caterer/MenuMaster/NutritionInfoNew';

const MealTypesText = {
    MEAL: 'Main course',
    SNACK: 'Snack',
    DINNER: 'Dinner',
    BREAKFAST: 'Breakfast',
    SIDE: 'Sides',
    EXTRA: 'A La Carte ',
    HOLIDAY: 'Holiday',
    ENTREE: "Entree",
    FRUIT: 'Fruit',
    MILK: 'Milk',
    VEGETABLES: "Vegetables"
}
const MTypes = {
    meal: 'MEAL',
    snack: 'SNACK',
    dinner: 'DINNER',
    breakfast: 'BREAKFAST',
    side: 'SIDE',
    extra: 'EXTRA',
    holiday: 'HOLIDAY',
    entree: "ENTREE",
    fruit: "FRUIT",
    milk: "MILK",
    vegetables: "VEGETABLES",
};
const infoModalStyles = {
    content: {

        overflow: 'auto',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '50%',
        transform: 'translate(-50%, -50%)',
        height: "100%",
        overflowY: "auto",
        maxHeight: '80vh',
    }
};
const mealItemObj = {
    "itemId": sessionStorage.getItem('menuItemId'),
    "calcium": 0,
    "calories": 0,
    "cholestral": 0,
    "copper": 0,
    "dietaryFiber": 0,
    "folate": 0,
    "iron": 0,
    "magnesium": 0,
    "manganese": 0,
    "niacin": 0,
    "pantothenicAcid": 0,
    "phosphorous": 0,
    "potassium": 0,
    "protein": 0,
    "riboFlavin": 0,
    "saturatedFat": 0,
    "selenium": 0,
    "sodium": 0,
    "sugars": 0,
    "thiamin": 0,
    "totalCarbohydrate": 0,
    "totalFat": 0,
    "vitaminA": 0,
    "vitaminB6": 0,
    "vitaminB12": 0,
    "vitaminC": 0,
    "vitaminD": 0,
    "vitaminE": 0,
    "vitaminK": 0,
    "zinc": 0,
    "isNutrAvailable": true,
}
class MonthCal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            sloading: false,
            nutritionInfoIsOpen: false,
            menuItemId: 0,
            menuItemRec: JSON.parse(JSON.stringify(mealItemObj)),
            nutritionCodeVal: {},
            nutritionVal: [],
            servings: {},
            nutritonMasterList: [],
            menuObj: [],
        }
    }
    componentWillMount = () => {
        this.getMenu();
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;

        this.getNutritionMasterList();
    }
    hideshowNutritionInfoOpen = () => {
        this.setState({
            nutritionInfoIsOpen: false,
            menuItemRec: JSON.parse(JSON.stringify(mealItemObj)),
            menuItemId: 0
        });
    }

    getMenu = () => {
        const { menuSummaryId } = this.props;
        this.setState({
            loading: true
        })
        //const _type=(mType===MealTypes.LUNCH) &&!isRegularLunchOrderType(this.state.isParent?this.state.studentData.mealSchoolId:0)?MenuOrderTypes.ITEMIZE:this.state.mealType;
        get(`/mealSummaryDetails?menuSummaryId=${menuSummaryId}&isViewMenu=true&access_token=`).then((response) => {
            //get('/mealSummaryDetails?menuSummaryId='+menuSummaryId+'&mealSchoolId=' + student.mealSchoolId+'&grade=' + student.gradeName+'&studentRecId='+student.id+ '&itemType='+mealType+'&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let _menuObj = {};
            let _initialPrices = {};
            const menuItemsList = ((data || {}).menuItemsList || []).sort((a, b) => {
                if (a.name < b.name) { return -1; }
                if (a.name > b.name) { return 1; }
                return 0;
            });

            this.setState({
                menuObj: menuItemsList,
                loading: false,
            })
        })
            .catch(
                (error) => {
                    this.setState({
                        menuObj: [],
                        loading: false,
                    })
                });
    }
    renderNutritionInfoIcon = (item) => {
        const nutritionInfo = ((item.isNutrAvailable || '') !== '' && item.isNutrAvailable) ? true : false;
        return ((nutritionInfo) ? null : <a title="Nutrition Info"
            href onClick={(e) => {
                const menuItemId = item.id
                //sessionStorage.setItem('menuItemId', menuItemId)
                this.setState({ nutritionInfoIsOpen: true, menuItem: item })
                this.getNutritionInfo(menuItemId)
            }} style={{ fontSize: '14px' }} >{<i className="fa fa-info-circle color-3"></i>}</a>)
    }
    renderDayEventList = (eventsObj, eventDate) => {
        const { student } = this.props
        const currency = currency_symbol(student.mealSchoolId)
        return (
            <Fragment>
                {
                    [...(eventsObj[MTypes.meal] || []), ...(eventsObj[MTypes.entree] || [])].length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.entree]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                [...(eventsObj[MTypes.meal] || []), ...(eventsObj[MTypes.entree] || [])].sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                                    const studentIsFreeMeal = ((student.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && student.beforeCare) ? true : false);
                                    const studentIsReducePrice = student.isReducePriceEligible || false;
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    return (<div className={item.isSelected ? "menuItem border noAction" : "menuItem"}
                                        style={allergy ? { backgroundColor: '#e5710d' } : {}}>{
                                            allergy ?
                                                <a href="#" title={item.desc}><span>{`${item.name} ${currency} ${(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.afterDiscountAmount : item.price))}`}</span></a> :
                                                <span>{`${item.name} ${currency} ${(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.afterDiscountAmount : item.price))} `}
                                                    {this.renderNutritionInfoIcon(item)}
                                                </span>
                                        }</div>)
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.vegetables] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.vegetables]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.vegetables] || []).sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                                    const studentIsFreeMeal = ((student.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && student.beforeCare) ? true : false);
                                    const studentIsReducePrice = student.isReducePriceEligible || false;
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    return (<div className={item.isSelected ? ("menuItem border") : ("menuItem")}
                                        style={allergy ? { backgroundColor: '#e5710d' } : {}} >{
                                            allergy ?
                                                <a href="#" title={item.desc}><span>{`${item.name} ${currency} ${(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.afterDiscountAmount : item.price))}`}</span></a> :
                                                <span>{`${item.name} ${currency} ${(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.afterDiscountAmount : item.price))} `}
                                                    {this.renderNutritionInfoIcon(item)}
                                                </span>
                                        }</div>)
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.fruit] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.fruit]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.fruit] || []).sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                                    const studentIsFreeMeal = ((student.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && student.beforeCare) ? true : false);
                                    const studentIsReducePrice = student.isReducePriceEligible || false;
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    return (<div className={item.isSelected ? ("menuItem border") : ("menuItem")}
                                        style={allergy ? { backgroundColor: '#e5710d' } : {}} >{
                                            allergy ?
                                                <a href="#" title={item.desc}><span>{`${item.name} ${currency} ${(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.afterDiscountAmount : item.price))}`}</span></a> :
                                                <span>{`${item.name} ${currency} ${(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.afterDiscountAmount : item.price))} `}
                                                    {this.renderNutritionInfoIcon(item)}
                                                </span>
                                        }</div>)
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.milk] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.milk]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.milk] || []).sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                                    const studentIsFreeMeal = ((student.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && student.beforeCare) ? true : false);
                                    const studentIsReducePrice = student.isReducePriceEligible || false;
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    return (<div className={item.isSelected ? ("menuItem border") : ("menuItem")}
                                        style={allergy ? { backgroundColor: '#e5710d' } : {}} >{
                                            allergy ?
                                                <a href="#" title={item.desc}><span>{`${item.name} ${currency} ${(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.afterDiscountAmount : item.price))}`}</span></a> :
                                                <span>{`${item.name} ${currency} ${(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.afterDiscountAmount : item.price))} `}
                                                    {this.renderNutritionInfoIcon(item)}
                                                </span>
                                        }</div>)
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.snack] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.snack]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.snack] || []).sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                                    const studentIsFreeMeal = ((student.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && student.beforeCare) ? true : false);
                                    const studentIsReducePrice = student.isReducePriceEligible || false;
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    return (<div className={item.isSelected ? ("menuItem border") : ("menuItem")}
                                        style={allergy ? { backgroundColor: '#e5710d' } : {}} >{
                                            allergy ?
                                                <a href="#" title={item.desc}><span>{`${item.name} ${currency} ${(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.afterDiscountAmount : item.price))}`}</span></a> :
                                                <span>{`${item.name} ${currency} ${(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.afterDiscountAmount : item.price))} `}
                                                    {this.renderNutritionInfoIcon(item)}
                                                </span>
                                        }</div>)
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.breakfast] || []).sort((a, b) => a.name.localeCompare(b.name)).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.breakfast]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.breakfast] || []).map(item => {
                                    const studentIsFreeMeal = ((student.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && student.beforeCare) ? true : false);
                                    const studentIsReducePrice = student.isReducePriceEligible || false;
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    return (<div className={item.isSelected ? ("menuItem border") : ("menuItem")}
                                        style={allergy ? { backgroundColor: '#e5710d' } : {}} >{
                                            allergy ?
                                                <a href="#" title={item.desc}><span>{`${item.name} ${currency} ${(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.afterDiscountAmount : item.price))}`}</span></a> :
                                                <span>{`${item.name} ${currency} ${(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.afterDiscountAmount : item.price))} `}
                                                    {this.renderNutritionInfoIcon(item)}
                                                </span>
                                        }</div>)
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.dinner] || []).sort((a, b) => a.name.localeCompare(b.name)).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.dinner]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.dinner] || []).map(item => {
                                    const studentIsFreeMeal = ((student.isFreeMealEligible || false) ? true : ((item.type === MTypes.breakfast) && student.beforeCare) ? true : false);
                                    const studentIsReducePrice = student.isReducePriceEligible || false;
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    return (<div className={item.isSelected ? ("menuItem border") : ("menuItem")}
                                        style={allergy ? { backgroundColor: '#e5710d' } : {}} >{
                                            allergy ?
                                                <a href="#" title={item.desc}><span>{`${item.name} ${currency} ${(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.afterDiscountAmount : item.price))}`}</span></a> :
                                                <span>{`${item.name} ${currency} ${(studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : (item.applyDiscount ? item.afterDiscountAmount : item.price))} `}
                                                    {this.renderNutritionInfoIcon(item)}
                                                </span>
                                        }</div>)
                                })
                            }
                        </Fragment> : null
                }

                {
                    (eventsObj[MTypes.side] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.side]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.side] || []).sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    return (
                                        item.isSideSelect ?
                                            <div className={item.isSelected ? ("menuItem border noAction") : ("menuItem")}
                                                style={allergy ? { backgroundColor: '#e5710d' } : {}} >{
                                                    allergy ?
                                                        <a href="#" title={item.desc}><span>{`${item.name} ${currency} ${item.price}`} {this.renderNutritionInfoIcon(item)}</span></a> :
                                                        <span>{`${item.name} ${currency} ${item.price}`}</span>
                                                }</div> :
                                            <div className={'menuItem border'}>
                                                <span>{`${item.name} ${currency} ${item.price} `} {this.renderNutritionInfoIcon(item)}</span>
                                            </div>
                                    )
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.extra] || []).length > 0 ?
                        <Fragment>
                            <p className="groupTitle">
                                <small>{MealTypesText[MTypes.extra]}</small>
                                <hr className="menuItemDivision" />
                            </p>
                            {
                                (eventsObj[MTypes.extra] || []).sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                                    const allergy = ((item.allergyAlert || '') !== '' && item.allergyAlert) ? true : false;
                                    return (
                                        <div className={item.isSelected ? ("menuItem border noAction") : ("menuItem")}
                                            style={allergy ? { backgroundColor: '#e5710d' } : {}} >{
                                                allergy ?
                                                    <a href="#" title={item.desc}><span>{`${item.name} ${currency} ${item.price}`}</span></a> :
                                                    <span>{`${item.name} ${currency} ${item.price} `} {this.renderNutritionInfoIcon(item)}</span>
                                            }</div>
                                    )
                                })
                            }
                        </Fragment> : null
                }
                {
                    (eventsObj[MTypes.holiday] || []).length > 0 ?

                        (eventsObj[MTypes.holiday] || []).sort((a, b) => a.name.localeCompare(b.name)).map(item => {
                            return <div className={"menuItem noSchool"}>
                                <span>{item.name}</span></div>
                        })
                        : null
                }
            </Fragment>);
    }
    getNutritionMasterList = async () => {
        const nutList = [];
        const res = await getAllNutrientData();
        if (!res.error) {
            const resp = res.data || [];
            resp.map(itm => {
                nutList.push({
                    ...itm,
                    nutrientDescriptions: [
                        {
                            nutrientDescription: `${itm.nutrientDescription}`,
                            nutrientUnit: `${itm.units}`
                        }
                    ]
                });
                if ((itm.subNutrients || []).length > 0) {
                    (itm.subNutrients || []).map(sitm => {
                        nutList.push({
                            parent: itm.nutrientCode,
                            ...sitm,
                            nutrientDescriptions: [
                                {
                                    nutrientDescription: `${sitm.nutrientDescription}`,
                                    nutrientUnit: `${sitm.units}`
                                }
                            ]
                        });
                    });
                }
            })
            this.setState({ nutritonMasterList: [...nutList] });
        }
    }
    getNutritionInfo = (menuItemId) => {
        this.setState({ sloading: true, menuItemRec: { ...mealItemObj, itemId: menuItemId } });
        get(`/menuItems/${menuItemId}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let _menuItemRec = data || {};
            let _mealRec = JSON.parse(JSON.stringify({ ...mealItemObj, itemId: menuItemId }));
            _mealRec = { ..._mealRec, ..._menuItemRec }
            this.setState({ sloading: false, menuItemRec: { ..._mealRec } })
            if (_mealRec.sourceRecipeId === undefined) {
                this.setState({ menuItemRec: { ...this.state.menuItemRec, imageUrl: null }, nutritionVal: [] });
            } else {
                getRecipesDataByCode(_mealRec.sourceRecipeId).then((resp) => {
                    if (!resp.ok) {
                        throw Error(resp.statusText);
                    }
                    return resp.json();
                }).then(respData => {
                    let nutritionData = [];
                    nutritionData = formatNutritionFacts((this.state.nutritonMasterList || []), (respData.nutrientValues || []), true, ((respData || []).servings || {}).size || 0);
                    const result = nutritionData.reduce((acc, item) => {
                        acc[item.nutrientCode] = item.nutrientValue;
                        return acc;
                    }, {});
                    this.setState({ menuItemRec: { ...this.state.menuItemRec, nutritionData, imageUrl: respData.imageUrl } })
                    this.setState({ nutritionCodeVal: { ...result } });
                    this.setState({ nutritionVal: nutritionData });
                    this.setState({ servings: respData.servings });
                }).catch(
                    (error) => {
                        this.setState({ sloading: false })
                    })
            }
        }).catch(
            (error) => {
                this.setState({ sloading: false })
                console.log('Get NutritionInfo response', error)
            }
        );
    }
    formatServiceData = (_menuObj, initformat = false) => {
        const studentData = this.state.studentData;
        let studentIsFreeMeal = ((studentData.isFreeMealEligible || false) ? true : ((this.state.mealType === MealTypes.BREAKFAST) && studentData.beforeCare) ? true : false);
        let studentIsReducePrice = studentData.isReducePriceEligible || false;
        let isExtraPreOrder = studentData.isExtraPreOrder || false;
        let allergyAlertTrue = false;
        let initPrice = 0.00;
        if (initformat) {
            (_menuObj.menuItemsList || []).map((item, i) => {
                const idx = _menuObj['orderedMenu'].findIndex(menuItem => {
                    return menuItem.mealCalendarId == item.mealCalendarId
                });
                if (idx > -1) {
                    if (item.type === MealTypes.EXTRA) {
                        item['isSelected'] = true;
                    }
                    else if (item.type === MealTypes.SIDE) {
                        if (_menuObj.isSideSelect) {
                            item['isSelected'] = true;
                        } else {
                            item['isSelected'] = false;
                        }
                    }
                    else {
                        item['isSelected'] = true;
                    }
                } else {
                    item['isSelected'] = false;
                }

                if (item.type == MealTypes.MEAL || item.type === MenuOrderTypes.ITEMIZE.toUpperCase() || item.type === MealTypes.SNACK.toUpperCase() || item.type === MealTypes.BREAKFAST.toUpperCase()) {
                    item.start = moment(item.start, 'YYYY-MM-DD');
                    item.end = moment(item.end, 'YYYY-MM-DD');
                } else {
                    if (item.type == MealTypes.EXTRA) {
                        item.start = moment(item.start, 'YYYY-MM-DD').set({ hours: 2, minutes: 0, seconds: 0 });
                        item.end = moment(item.end, 'YYYY-MM-DD').set({ hours: 2, minutes: 0, seconds: 0 });
                    } else {
                        item.start = moment(item.start, 'YYYY-MM-DD').set({ hours: 1, minutes: 0, seconds: 0 });
                        item.end = moment(item.end, 'YYYY-MM-DD').set({ hours: 1, minutes: 0, seconds: 0 });
                    }
                }
                item.start = moment(item.start, 'YYYY-MM-DD');
                item.end = moment(item.end, 'YYYY-MM-DD');
                item.eventId = i;
                item.isSideSelect = _menuObj.isSideSelect;
                item.title = item.name
            });
            _menuObj['allergyAlertTrue'] = allergyAlertTrue;
            _menuObj['isSideSelect'] = _menuObj.isSideSelect;
        }

        const { applyDiscount, itemPriceDisForMonthlyOrder } = this.calculateDiscount(_menuObj);
        let _initPrices = 0;
        (_menuObj.menuItemsList || []).map(item => {
            if (item.type === MealTypes.EXTRA && item.isSelected) {
                _initPrices += parseFloat(convertTwoDecimalPoint(item.price, 2));
            }
            else if (item.type === MealTypes.SIDE && item.isSelected) {
                _initPrices += parseFloat(convertTwoDecimalPoint((studentIsFreeMeal ? 0 : (studentIsReducePrice) ? item.reducedPrice : item.price), 2))
            } else {
                if (item.isSelected) {
                    if (studentIsFreeMeal) {
                        _initPrices += 0;
                    } else if (studentIsReducePrice) {
                        _initPrices += parseFloat(convertTwoDecimalPoint(item.reducedPrice, 2));
                    } else {
                        item['applyDiscount'] = applyDiscount;
                        item['itemPriceDisForMonthlyOrder'] = itemPriceDisForMonthlyOrder;
                        item['afterDiscountAmount'] = parseFloat(convertTwoDecimalPoint(item.price, 2)) - parseFloat(convertTwoDecimalPoint(itemPriceDisForMonthlyOrder, 2));
                        _initPrices += applyDiscount ? item.afterDiscountAmount : parseFloat(convertTwoDecimalPoint(item.price, 2));
                    }
                }
            }
        });
        return {
            menuObj: _menuObj,
            initPrice: _initPrices,
            allergyAlertTrue: allergyAlertTrue
        }
    }
    render() {
        const { yearMonth, student } = this.props;
        return (
            <Fragment>
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.sloading}
                    />
                </div>

                {
                    this.state.loading ?
                        <div className="text-center">
                            <label>Loading.....</label>
                        </div> :
                        <Fragment>
                            <MonthCalender
                                id={`cCal-${yearMonth}`}
                                ref={(c) => { this[`ref-c${yearMonth}`] = c }}
                                hiddenDays={getNotWorkingDays(this.props.isParent ? student.mealSchoolId : 0)}
                                defaultDate={moment(yearMonth, 'YYYYMM')}
                                events={this.state.menuObj || []}
                                //eventClick={ this.selectEvent}
                                renderDayEventList={this.renderDayEventList}
                            />
                            <Modal isOpen={this.state.nutritionInfoIsOpen}
                                onRequestClose={() => this.setState({ nutritionInfoIsOpen: false })}
                                style={infoModalStyles}
                                contentLabel="Nutrition Info"
                            >
                                <div>
                                    <div className="modal-header">
                                        <h4 className="modal-title modal-title-color" id="deleteLabel">Nutrition Info</h4>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row">
                                            <form>
                                                <div className="col-sm-12 col-md-12">
                                                    <div className="form-group">
                                                        <NutritioninfoNew nutritionCodeVal={this.state.nutritionCodeVal} data={this.state.menuItemRec} nutritionVal={this.state.nutritionVal} servings={this.state.servings} />
                                                    </div>

                                                    <div className="from-group text-right">
                                                        <button type="button" className="btn bg-color-4" onClick={(e) => {
                                                            this.hideshowNutritionInfoOpen(e);
                                                        }}>Back</button>
                                                    </div>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                </div>
                            </Modal>
                        </Fragment>
                }
            </Fragment>
        );
    }
}

export default MonthCal;


// WEBPACK FOOTER //
// ./src/components/Parent/viewMenu/monthCal.jsx